import React, {useState} from 'react';
import styled from '@emotion/styled';
import MenuItem from '@material-ui/core/MenuItem';
import CustomInputField from '../common/CustomInputField';
import ActionButton3 from '../common/Action Buttons/ActionButton3';
import ActionButton from '../common/Action Buttons/ActionButton';
import ActionButton2 from '../common/Action Buttons/ActionButton2';
import ActionButton3FileInput from '../common/Action Buttons/ActionButton3FileInput';
import {getCustomerDocument} from '../../api/network/businessCustomerService';
import {downloadDocument} from '../../api/network/documentService';
import UserRole from '../common/UserRole';
import {roles} from '../../utils/auth';
import CustomSelection from '../common/CustomSelection';

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: fit-content;
    height: 95%;
    justify-content: space-between;
    
    padding-left: 82px;
    padding-top: 82px;
    //padding-bottom: 54px;
`;

const ContentRows = styled.div`
    display: flex;
    flex-direction: column;
    
    //width: 474px;
`;

const ContentRow = styled.div`
  display: grid;
  width: fit-content;
  grid-auto-flow: column;
  grid-column-gap: 24px;
  
  margin-bottom: 40px;
  
  * {
    margin-right: 20px;
  }
  
`;

const ActionsWrapper = styled.div`
    //position: absolute;
    bottom: 0;
    width: 100%;
    height: fit-content;
    
    margin-bottom: 40px;
    
    display: flex;
    flex-direction: row;
    justify-content: start;
    padding-top: 10px;
    
     > * {
      margin-right: 24px;
    }
`;

const styles = {
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '36px'
    }
};

function ProfileIdentityContent({companyName, yearsOfBusiness, repTrn, trn, priceTier, onFieldChange, onSaveClick, onFileChange, onDocumentView, isIndividual, userRole, docs, tiers, ...props}) {
    const [saveEnabled, setSaveEnabled] = useState(false);
    // TODO consider handling enabling save state out side in top container

    const handleOnFieldChange = e => {
        onFieldChange(e);
        setSaveEnabled(true);
    };

    console.log('hello', companyName, priceTier, props);

    return (
        <ContentWrapper>
            <ContentRows>
                <ContentRow>
                    <CustomInputField
                        label={isIndividual ? 'Account Name' : 'Company'}
                        name="companyName"
                        value={companyName}
                        placeholder=""
                        width={309}
                        onChange={handleOnFieldChange}
                    />

                    {
                        !isIndividual &&
                        <CustomInputField
                            label="Established"
                            name="yearsOfBusiness"
                            value={yearsOfBusiness}
                            mask="9999"
                            placeholder=""
                            onChange={handleOnFieldChange}
                        />
                    }

                </ContentRow>
                <ContentRow>

                    <CustomInputField
                        label={isIndividual ? 'TRN' : 'Company TRN'}
                        name="trn"
                        value={trn}
                        mask="999 999 999"
                        placeholder=""
                        width={309}
                        onChange={handleOnFieldChange}
                    />
                </ContentRow>
                {
                    userRole === roles.BAM && <ContentRow>

                        {/* TODO: manually passing name to handleOnFieldChange because it's not seeing getting the name variable for some reason; look into that later */}
                        <CustomSelection
                            label="Price Tier"
                            value={priceTier || 0}
                            name="priceTier"
                            placeholder=""
                            width={309}
                            onChange={e => handleOnFieldChange({
                                target: {
                                    value: e.target.value,
                                    name: 'priceTier'
                                }
                            })}
                        >
                            {
                                tiers.map(tier => (
                                    <MenuItem
                                        key={tier.tier}
                                        name="priceTier"
                                        value={tier.tier}
                                    >
                                        {tier.name}{tier.value ? ` (${`${tier.value}%) ${tier.up ? 'Markup' : 'Markdown'}`}` : ''}
                                    </MenuItem>
                                ))
                            }
                        </CustomSelection>
                    </ContentRow>
                }

                {/*DOCUMENTS*/}

                {
                    docs.map((item, index) => (
                        <div style={styles.row}>
                            <div>{item.title}</div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row'
                            }}
                            >
                                <ActionButton3 onClick={() => onDocumentView(item)} disabled={!item?.documentId}>
                                    view
                                </ActionButton3>

                                <div style={{width: 20}}/>

                                {
                                    // SHOW ONLY FOR BAM AND CUSTOMER
                                    (userRole === roles.BAM || userRole === roles.CUSTOMER_REP) &&
                                    <ActionButton3FileInput
                                        fileName={item.documentType?.name}
                                        label="upload"
                                        onChange={e => onFileChange(e, index)}
                                        showFileLable={true}
                                    />
                                }
                            </div>
                        </div>
                    ))
                }

            </ContentRows>

            <ActionsWrapper>
                <ActionButton onClick={onSaveClick}>Save</ActionButton>
            </ActionsWrapper>
        </ContentWrapper>
    );
}

ProfileIdentityContent.propTypes = {};
ProfileIdentityContent.defaultProps = {};

export default ProfileIdentityContent;
